import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IQuestion } from '../../models/question'
import { logout, refreshSession } from '../actions/constants'

export interface IQuestionsState {
  questions: IQuestion[]
}

const initialState: IQuestionsState = {
  questions: []
}

export const questionsSlice = createSlice({
  name: 'questions',
  initialState,
  reducers: {
    setQuestions: (state, action: PayloadAction<IQuestion[]>) => {
      state.questions = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const {
  setQuestions
} = questionsSlice.actions

export default questionsSlice.reducer
